import Vue from 'vue'
import App from './App.vue'
import router from './router'

import "./assets/reset.css";


// import store from './vuex/modules/frootwheel'

Vue.config.productionTip = false

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
